<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.legal_entity }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">ИНН</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.individual_taxpayer_number }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">№ договора</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.contract_id || '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Дата договора</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.contract_date || '' }}</CCol>
                    </CRow>
                    <PartnerSigners :signers="partner.signers" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Комиссия VIP MIRCITY (%)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            partner.commission ? `${partner.commission}%` : ''
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Комиссия VIP MIRCITY (руб)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            partner.commission_sum ? `${partner.commission_sum} руб` : ''
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge
                                :color="getBadge(partner.enabled)"
                            >&nbsp;{{ partner.enabled ? "Да" : "Нет" }}&nbsp;</CBadge
                            >
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Создан</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            formatDate(partner.created_at)
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Изменен</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            formatDate(partner.updated_at)
                        }}</CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/VipPartnersTabLinks';
    import PartnerSigners from '@/components/partner/PartnerSigners';
    import { paymentTypeTitle } from '../../utils/payment-views';
    import { formatDate } from '../../utils/views';
    import { REPORT_FREQUENCY_TITLE } from '../../utils/partner';

    export default {

        name: 'Partner',
        components: {
            PartnersTabLinks,
            PartnerSigners,
        },

        data() {
            return {
                REPORT_FREQUENCY_TITLE,
                partner: {},
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
            };
        },

        computed: {
            vat() {
                return this.vatOptions.find(item => item.value === this.partner.vat).label;
            }
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/vip-partners/' + id)
                .then(resp => {
                    this.partner = resp.data;
                    //this.$route.meta.label = this.partner.title;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            goBack() {
                this.$router.push({ path: '/vip-partners' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            paymentTypeTitle(paymentTypeId) {
                return paymentTypeTitle(paymentTypeId);
            },
            formatDate(date) {
                return formatDate(date);
            },
        },
    };
</script>
